export default [
  'login',
  'home',
  'profile',
  'changePassword',
  'minute',
]